<template>
  <div class="pb-4">
    <p class="mb-4 text-primary">
      Данные в шаблоне обновляются по мере наполнения вашей анкеты. По нажатию
      будет скачан файл, включающий указанные вами данные в анкете.
    </p>
    <UIFileTile
      :action="downloadTemplate"
      name="Предзаполненный шаблон.docx"
      extension="docx"
      type="word"
      :human_size="formatBytes(context.file[0].size)"
    />

    <a
      class="block cursor-pointer mt-8 text-primary text-sm"
      @click="downloadEmptyTemplate"
      target="_blank"
      download
    >
      Скачать шаблон без автоматического заполнения
    </a>
  </div>
</template>

<script setup>
import { notify } from 'notiwind'
import { inject } from 'vue'

import { formatBytes } from '../../../utils/global.js'
import UIFileTile from '../../ui/UIFileTile.vue'

const props = defineProps({
  modelValue: { type: [String, Number] },
  context: { type: Object, required: true },
  globalModel: { type: Object },
  type: { type: Object },
  passed: { type: Boolean },
  uuid: { type: String, required: true },
})

const http = inject('http')

async function downloadFile(url, options, fileName) {
  try {
    const response = await http(url, options)
    const blobUrl = window.URL.createObjectURL(new Blob([response]))
    const link = document.createElement('a')
    link.href = blobUrl
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(blobUrl)
  } catch (error) {
    notify({
      group: 'default',
      type: 'error',
      title: 'Произошла ошибка',
      text: 'Воспользуйтесь прямой ссылкой для заполнения шаблона',
    })
  }
}

function downloadTemplate() {
  downloadFile(
    `/form-builder/blocks/${props.uuid}/template`,
    {
      method: 'POST',
      body: props.globalModel,
      responseType: 'blob',
    },
    'Шаблон.docx',
  )
}

function downloadEmptyTemplate() {
  downloadFile(
    `/form-builder/blocks/${props.uuid}/template`,
    {
      method: 'POST',
      responseType: 'blob',
    },
    'Шаблон.docx',
  )
}
</script>
